module.exports = __webpack_public_path__ + "img/GNKUY.66be10e5.png";